
import { useState, useEffect } from 'react';
import Button from '../base/Button';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/ffceab47-7a7e-469f-b5af-3ab5e479fce7.png" 
              alt="ELTROM S.R.L." 
              className="h-10 w-auto"
            />
            <h1 className={`text-xl font-bold ${isScrolled ? 'text-[#0A1628]' : 'text-white'}`}>
              ELTROM
            </h1>
          </div>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center space-x-8">
            {[
              { name: 'Home', id: 'home' },
              { name: 'VPN', id: 'vpn' },
              { name: 'Features', id: 'features' },
              { name: 'About', id: 'about' },
              { name: 'Contact', id: 'contact' },
              { name: 'Support', id: 'support' }
            ].map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`font-medium transition-colors duration-200 hover:text-[#00D9FF] cursor-pointer ${
                  isScrolled ? 'text-[#0A1628]' : 'text-white'
                }`}
              >
                {item.name}
              </button>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button 
              variant="primary" 
              size="md"
              onClick={() => scrollToSection('contact')}
            >
              Get Started
              <i className="ri-arrow-right-line ml-2"></i>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2">
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-[#0A1628]' : 'text-white'}`}></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
